module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff
// module id = ../../../../bootstrap/dist/fonts/glyphicons-halflings-regular.woff
// module chunks = 2